import React, { useCallback, useMemo, useState } from 'react'

import TrainingJourneyContext from 'contexts/TrainingJourneyContext'
import useAuthTraining from 'hooks/useAuthTraining'

const TrainingJourneyProvider = ({ children }) => {
  const { accessType, company, linkInvalid, loginMode, portalToken } =
    useAuthTraining()

  const [activeStep, setActiveStep] = useState(0)
  const [formData, setFormData] = useState({})

  const handleNext = useCallback(() => setActiveStep((prev) => prev + 1), [])

  const contextValue = useMemo(
    () => ({
      accessType,
      activeStep,
      company,
      formData,
      handleNext,
      linkInvalid,
      loginMode,
      portalToken,
      setActiveStep,
      setFormData,
    }),
    [
      accessType,
      activeStep,
      company,
      formData,
      handleNext,
      linkInvalid,
      loginMode,
      portalToken,
    ],
  )

  return (
    <TrainingJourneyContext.Provider value={contextValue}>
      {children}
    </TrainingJourneyContext.Provider>
  )
}

export default TrainingJourneyProvider
